import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';
import buildPath from '@/tsClient/utilities/buildPath';

type THIS_API = ApiDefinition['/pacer-emails/creator/{creatorId}/get-pacer-workflow-names']['GET'];
type Input = THIS_API['params'];
type Output = THIS_API['response'];

const PATH_TEMPLATE = '/pacer-emails/creator/{creatorId}/get-pacer-workflow-names';

const getUniqueWorkflowNamesFromPacer = async ({ creatorId }: Input): Promise<Output> => {
  const path = buildPath<THIS_API>(PATH_TEMPLATE, { creatorId });
  const response = await noodleApiClient.get(path);
  return response.data;
};

export default getUniqueWorkflowNamesFromPacer;
